export default "__VITE_ASSET__Dv49W2lu__"